<template>
  <div>
    <StickyHScroll>
    <v-data-table
      :headers="getHeadersByRole($store.getters.role)"
      :items="institutions"
      :search="search"
      :custom-filter="filterInstitutions"
      :loading="loading"
      item-value="title"
      :items-per-page="-1"
      hide-default-footer
      class="elevation-1 nowrap-headers pb-8"
    >
      <template #progress>
        <v-progress-linear color="red" indeterminate />
      </template>
      <template #item="{ item, index }">
        <tr
          :class="{ tableRowColorSelected: index == activeRow }"
          class="tableRowColor"
          @click="activeRow = index"
        >
          <!-- Status -->
          <td class="text-xs text-truncate">
            <v-icon v-if="item.user_status"> mdi-check-circle-outline </v-icon>
            <br />
            <span>{{ item._id.slice(-4) }}</span>
          </td>
          <!-- Actions -->
          <td
            v-if="
              $store.getters.role == 'LekoAdmin' ||
              $store.getters.role == 'LekoEmployee' ||
              $store.getters.role == 'SuperAdmin'
            "
            class="text-xs-center"
          >
            <v-row class="d-flex flex-nowrap">
              <v-icon class="mr-2 pointer" @click="editCars(item._id)">
                mdi-car
              </v-icon>
              <v-icon class="mr-2 pointer" @click="editInstitution(item)">
                mdi-pencil
              </v-icon>
              <v-icon class="mr-2 pointer" @click="deleteInstitution(item._id)">
                mdi-delete
              </v-icon>
            </v-row>
          </td>

          <!-- Created At -->
          <td v-if="item.date_created" class="text-xs-center">
            <v-btn color="black" variant="outlined" small>
              {{ formatDate(item.date_created) }}
            </v-btn>
          </td>
          <td v-if="!item.date_created" class="text-xs-center">
            <v-btn color="black" variant="outlined" small>
              {{ formatDate(todayDate) }}
            </v-btn>
          </td>
          <!-- Profile Details -->
          <td class="text-xs text-truncate" style="height: 150px">
            <a @click="showDetails(item)">
              <strong>
                <v-icon small> mdi-fireplace-off </v-icon>
                {{ item.title }}
              </strong>
            </a>
            <br />
            <v-icon small> mdi-map-marker-outline </v-icon>
            {{ item.address }} <br />
            <v-icon small> mdi-fireplace-off</v-icon>
            {{ item.city }}, {{ item.state }} <br />
            <v-icon small> mdi-email </v-icon>
            {{ item.email }}<br />
            <v-icon small> mdi-phone </v-icon>
            {{ item.phone }}<br />
            <a :href="item.website" target="_blank">
              <v-icon small> mdi-web-box </v-icon> {{ item.website }}</a
            ><br />
            <a :href="item.shop" target="_blank">
              <v-icon small> mdi-store </v-icon> {{ item.shop }}</a
            >
          </td>
          <!-- Logo -->
          <td>
            <v-row align-center justify-center>
              <img
                v-if="item.logo"
                :src="
                  item && item.logo
                    ? `https://leko-tech.fra1.cdn.digitaloceanspaces.com/${item.logo}`
                    : `https://portal.lekotech.com/logo_small.png`
                "
                style="width: 170px; height: 70px"
              />
            </v-row>
          </td>

          <!-- Lekotech Shop -->
          <!-- <td class="text-xs">
          <a
            :href="item.shop"
            target="_blank"
          >{{ item.shop }}</a>
        </td> -->

          <!-- Cars -->
          <td class="text-xs">
            <span class="d-flex">
              <v-icon color="grey-darken-2" class="mt-2"
                >mdi-car-multiple</v-icon
              >
              <v-chip>
                {{ item.carsCount }}
              </v-chip>
            </span>
          </td>

          <!-- Users -->
          <td class="text-xs">
            <span class="d-flex">
              <v-icon color="grey-darken-2" class="mt-2"
                >mdi-account-group</v-icon
              >
              <v-chip>
                {{ item.usersCount }}
              </v-chip>
            </span>
          </td>
            <!-- RR -->
          <td class="text-xs">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100px;
              "
            >
              <span>{{ $t("institutions.table.aziendaRR") }}</span>
              <v-icon v-if="item.aziendaRR">
                mdi-check-circle-outline
              </v-icon>
               <v-icon v-else>
                mdi-circle-outline
              </v-icon>
            </div>
            <br />
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100px;
              "
            >
              <span>{{ $t("institutions.table.rr_member") }}</span>
              <v-icon v-if="item.rrMember">
                 mdi-check-circle-outline
              </v-icon>
               <v-icon v-else>
                mdi-circle-outline
              </v-icon>
            </div>
            <br />
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100px;
              "
            >
              <span>RR</span>
              <v-icon v-if="item.rr">
                mdi-check-circle-outline
              </v-icon>
              <v-icon v-else>
                mdi-circle-outline
              </v-icon>
            </div>
            <br />
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 100px;
              "
            >
              <span>eBay</span>
              <v-icon v-if="item.export_ebay_leko">
                mdi-check-circle-outline
              </v-icon>
              <v-icon v-else>
                mdi-circle-outline
              </v-icon>
            </div>
          </td>
          <!-- Used / Remaining Plates -->
          <td class="text-xs text-truncate">
            <div class="d-block text-center">
              <span>
                {{ $t("institutions.form.total_plates") }} /{{ $t("institutions.form.remaining_plates") }}
               
              </span><br></br>
              <span>
                {{
                  item.plates.used
                }}/
                {{ item.plates.remaining }}
              </span>
            </div>
          </td>
          <!-- Used Plates Monthly -->
          <td class="text-xs text-center">
            {{ item.usedPlatesNumber }}
          </td>
          <!-- Parts -->
          <td class="text-xs">
            {{ item.partsCount }}
          </td>
          <!--        <td-->
          <!--          class="text-xs-center"-->
          <!--        >-->
          <!--          <v-icon v-if="item.export_parts">-->
          <!--            check_circle-->
          <!--          </v-icon>-->
          <!--        </td>-->
          <td class="text-xs-center">
            {{ item.temporaryPartsCount }}
          </td>
          <!--        <td-->
          <!--          class="text-xs-center"-->
          <!--        >-->
          <!--          <v-icon v-if="item.export_temporary_parts">-->
          <!--            check_circle-->
          <!--          </v-icon>-->
          <!--        </td>-->
          <td class="text-xs-left">
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 200px;
              "
            >
              <span>{{ $t("institutions.table.exportParts") }}</span>
              <v-icon v-if="item.export_parts">
                mdi-check-circle-outline
              </v-icon>
            </div>
            <br />
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 200px;
              "
            >
              <span>{{ $t("institutions.table.exportTempParts") }}</span>
              <v-icon v-if="item.export_temporary_parts">
                mdi-check-circle-outline
              </v-icon>
            </div>
            <br />
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 200px;
              "
            >
              <span>{{ $t("institutions.table.exportSales") }}</span>
              <v-icon v-if="item.export_sales">
                mdi-check-circle-outline
              </v-icon>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
    </StickyHScroll>
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" :value="true" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import getRequest from "../../api/getRequest";
import deleteRequest from "../../api/deleteRequest";
import institutionDetails from "@/components/Institutions/institutionDetails.vue";

export default {
  components: {
    institutionDetails,
  },
  props: {
    search: {
      type: String,
      default: "",
    },
  },
  data: () => ({
    todayDate: new Date(),
    headers: [
      {
        title: "",
        sortable: true,
        key: "user_status",
      },
      {
        title: "",
        sortable: false,
        key: "actions",
      },
      {
        title: "",
        sortable: true,
        key: "date_created",
      },
      {
        title: "",
        sortable: false,
        key: "profile",
      },
      {
        title: "",
        sortable: false,
        key: "title",
      },
      // {
      //   title: '',
      //   sortable: false,
      //   key: 'shop',
      // },
      // {
      //   title: '',
      //   sortable: false,
      //   key: 'type',
      // },
      {
        title: "",
        sortable: true,
        key: "carsCount",
      },
      {
        title: "",
        sortable: false,
        key: "nrUsers",
      },
      {
        title: "RR",
        sortable: true,
        key: "rr",
      },
      {
        title: "",
        sortable: true,
        key: "plates.remaining",
      },
      {
        title: "",
        sortable: true,
        key: "usedPlatesNumber",
      },
      {
        title: "",
        sortable: true,
        key: "partsCount",
      },
      // {
      //   title: '',
      //   sortable: false,
      //   key: 'export_parts',
      // },
      {
        title: "",
        sortable: true,
        key: "temporaryPartsCount",
      },
      // {
      //   title: '',
      //   sortable: false,
      //   key: 'export_temporary_parts',
      // },
      {
        title: "",
        sortable: false,
        key: "export_sales",
      },
    ],
    superAdminHeaders: [
      {
        title: "",
        sortable: true,
        key: "user_status",
      },
      {
        title: "",
        sortable: false,
      },
      {
        title: "",
        sortable: true,
        key: "date_created",
      },
      {
        title: "",
        sortable: false,
        key: "profile",
      },
      {
        title: "",
        sortable: false,
        key: "logo",
      },
      {
        title: "",
        sortable: true,
        key: "carsCount",
      },
      {
        title: "",
        sortable: false,
        key: "nrUsers",
      },
      {
        title: "RR",
        sortable: true,
        key: "rr",
      },
      {
        title: "",
        sortable: true,
        key: "plates.remaining",
      },
      {
        title: "",
        sortable: true,
        key: "usedPlatesNumber",
      },
      {
        title: "",
        sortable: true,
        key: "partsCount",
      },
      {
        title: "",
        sortable: true,
        key: "temporaryPartsCount",
      },
      {
        title: "",
        sortable: false,
        key: "export_sales",
      },
    ],
    pagination: {
      groupBy: ["user_status"],
      sortBy: ["user_status"],
      sortDesc: [true],
      page: 1,
    },
    institutions: [],
    loading: false,
    activeRow: null,
    searchField: "",
    dialogDelete: false,
    institutionToDelete: null,
    filteredInstitutions: [],
    count: 0,
  }),
  computed: {
    server() {
      return this.$serverUri;
    },
  },
  watch: {
    "$i18n.locale"() {
      this.getLocale();
    },
  },
  created() {
    this.getLocale();
  },
  beforeMount() {
    this.getInstitutions();
  },
  methods: {
    getHeadersByRole(role) {
      if (role === "SuperAdmin") {
        return this.superAdminHeaders;
      }
      return this.headers;
    },
    showDetails(item) {
      if (this.$store.getters.role === "SuperAdmin") {
        // Navigate to the institution details page and pass the institution data
        this.$router.push(`/institution/${item._id}`);
      } else {
        // cannot have access
      }
    },
    formatDate(date) {
      if (!date) return "";
      moment.locale(localStorage.getItem("language") || "en");
      return moment(date).format("D MMMM YYYY");
    },
    filterInstitutions(value, search, item) {
      if (!search) return true;
      const term = search.toLowerCase();
      return (
        item.raw.title?.toLowerCase().includes(term) ||
        item.raw.email?.toLowerCase().includes(term)
      );
    },
    getLocale() {
      this.headers[0].title = this.$t("institutions.table.users");
      this.headers[1].title = this.$t("institutions.table.actions");
      this.headers[2].title = this.$t("institutions.table.createdDate");
      this.headers[3].title = this.$t("institutions.table.profile");
      this.headers[4].title = this.$t("institutions.table.logo");
      // this.headers[5].title = this.$t('institutions.table.shop');
      // this.headers[6].title = this.$t('institutions.table.type');
      this.headers[5].title = this.$t("institutions.table.cars");
      this.headers[6].title = this.$t("institutions.table.users");
      this.headers[7].title = 'RR';
      this.headers[8].title = this.$t("institutions.form.plates");
      this.headers[9].title = this.$t("institutions.form.used_plates");
      this.headers[10].title = this.$t("institutions.table.inventory");
      // this.headers[10].title = this.$t('institutions.table.exportParts');
      this.headers[11].title = this.$t("parts.insert_parts.inserted_parts");
      // this.headers[12].title = this.$t('institutions.table.exportTempParts');
      this.headers[12].title = this.$t("institutions.table.exportSales");

      // SuperAdmin headers
      this.superAdminHeaders[0].title = this.$t("institutions.table.users");
      this.superAdminHeaders[1].title = this.$t("institutions.table.actions");
      this.superAdminHeaders[2].title = this.$t(
        "institutions.table.createdDate",
      );
      this.superAdminHeaders[3].title = this.$t("institutions.table.logo");
      this.superAdminHeaders[4].title = this.$t("institutions.table.shop");
      this.superAdminHeaders[5].title = this.$t("institutions.table.cars");
      this.superAdminHeaders[6].title = this.$t("institutions.table.users");
       this.headers[7].title = 'RR';
      this.superAdminHeaders[8].title = this.$t("institutions.form.plates");
      this.superAdminHeaders[9].title = this.$t(
        "institutions.form.used_plates",
      );
      this.superAdminHeaders[10].title = this.$t("institutions.table.inventory");
      this.superAdminHeaders[11].title = this.$t(
        "parts.insert_parts.inserted_parts",
      );
      this.superAdminHeaders[12].title = this.$t(
        "institutions.table.exportSales",
      );
    },
    getInstitutions() {
      this.loading = true;
      getRequest("/institution/")
        .then((response) => {
          this.institutions = response.institutions;
          this.count = response && response.institutions ?
          response.institutions.length : 0;
          this.$emit("count", this.count);
          this.filteredInstitutions = response.institutions;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$emit("error", error);
        });
    },
    editInstitution(data) {
      this.$emit("edit", data);
    },
    editCars(id) {
      this.$emit("cars", id);
    },
    deleteInstitution(id) {
      this.institutionToDelete = id;
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loading = true;
      deleteRequest("/institution", `id=${this.institutionToDelete}`)
        .then(() => {
          this.dialogDelete = false;
          this.institutionToDelete = null;
          this.loading = false;
          this.getInstitutions();
        })
        .catch((error) => {
          this.dialogDelete = false;
          this.institutionToDelete = null;
          this.loading = false;
          this.$emit("error", error);
        });
    },
  },
};
</script>
